import { useContext } from 'react'

import {
  PreviewControlContext,
  PreviewControlValue,
} from './previewControlContext'

/**
 * プレビュー（おためしプレイ）の再生制御を取得する。
 * Provider 未配置では no-op を返すため、editor 以外のページでも安全に呼べる。
 */
export const usePreviewControl = (): PreviewControlValue =>
  useContext(PreviewControlContext)
